export default __webpack_public_path__ + "static/media/review.d00670e7.svg";